import { Options } from 'vue-class-component';
import ThermoPreferenceComponent from '../ThermoPreferenceComponent';
import { ThermoTypeOfObject } from '@/../client-generator/generated-clients/device-settings';
import {
  formattedTimeToSeconds,
  secondsToFormattedTime,
} from '@/core/utils/utils';

@Options({
  name: 'PreferenceRegulationBand',
  watch: {
    heatingRegulationBand: function (newValue: number, oldValue) {
      if (!oldValue) return;
      this.roomObject.heatingRegulationBand = newValue / 100;
    },
    fanSpeed2ForHeating: function (newValue: number, oldValue) {
      if (!oldValue) return;
      this.roomObject.fanSpeed2ForHeating = newValue / 100;
    },
    fanSpeed3ForHeating: function (newValue: number, oldValue) {
      if (!oldValue) return;
      this.roomObject.fanSpeed3ForHeating = newValue / 100;
    },
    coolingRegulationBand: function (newValue: number, oldValue) {
      if (!oldValue) return;
      this.roomObject.coolingRegulationBand = newValue / 100;
    },
    fanSpeed2ForCooling: function (newValue: number, oldValue) {
      if (!oldValue) return;
      this.roomObject.fanSpeed2ForCooling = newValue / 100;
    },
    fanSpeed3ForCooling: function (newValue: number, oldValue) {
      if (!oldValue) return;
      this.roomObject.fanSpeed3ForCooling = newValue / 100;
    },
    valvesTimeForHeatingFanCoil: function (newValue, oldValue) {
      if (!oldValue) return;
      this.roomOjbect.valvesTimeForHeatingFanCoil = secondsToFormattedTime(
        newValue
      );
    },
    valvesTimeForCoolingFanCoil: function (newValue, oldValue) {
      if (!oldValue) return;
      this.roomOjbect.valvesTimeForCoolingFanCoil = secondsToFormattedTime(
        newValue
      );
    },
  },
})
export default class PreferenceRegulationBand extends ThermoPreferenceComponent {
  ThermoTypeOfObject = ThermoTypeOfObject;

  heatingRegulationBand = 1;
  fanSpeed2ForHeating = 2;
  fanSpeed3ForHeating = 3;

  coolingRegulationBand = 1;
  fanSpeed2ForCooling = 2;
  fanSpeed3ForCooling = 3;

  valvesTimeForHeatingFanCoil = 0;
  valvesTimeForCoolingFanCoil = 0;

  mounted() {
    if (this.roomObject.heatingRegulationBand) {
      this.heatingRegulationBand = this.roomObject.heatingRegulationBand * 100;
    }

    if (this.roomObject.fanSpeed2ForHeating) {
      this.fanSpeed2ForHeating = this.roomObject.fanSpeed2ForHeating * 100;
    }

    if (this.roomObject.fanSpeed3ForHeating) {
      this.fanSpeed3ForHeating = this.roomObject.fanSpeed3ForHeating * 100;
    }

    if (this.roomObject.coolingRegulationBand) {
      this.coolingRegulationBand = this.roomObject.coolingRegulationBand * 100;
    }

    if (this.roomObject.fanSpeed2ForCooling) {
      this.fanSpeed2ForCooling = this.roomObject.fanSpeed2ForCooling * 100;
    }

    if (this.roomObject.fanSpeed3ForCooling) {
      this.fanSpeed3ForCooling = this.roomObject.fanSpeed3ForCooling * 100;
    }

    if (this.roomObject.valvesTimeForHeatingFanCoil !== '00:00:00') {
      this.valvesTimeForHeatingFanCoil = formattedTimeToSeconds(
        this.roomObject.valvesTimeForHeatingFanCoil as string
      );
    }

    if (this.roomObject.valvesTimeForCoolingFanCoil !== '00:00:00') {
      this.valvesTimeForCoolingFanCoil = formattedTimeToSeconds(
        this.roomObject.valvesTimeForCoolingFanCoil as string
      );
    }
  }
}
